import { CSSObject } from "@emotion/react";
import {
  constants,
  typographyStyles,
  mediaQueryStyles,
} from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const {
  BreakpointNames: { xs, md },
} = constants.breakpoints;

export const contentRowContainerCss: CSSObject = {
  background: constants.colors.ui.white[50],
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  borderRadius: 16,
  padding: "16px 24px",
};

export const contentRowLabelCss: CSSObject = {
  ...typographyStyles.fontFamily.circular,
  ...typographyStyles.fontSize.heading6,
  background: constants.colors.ui.red[600],
  color: constants.colors.ui.white[50],
  width: "fit-content",
  fontWeight: 600,
  marginBottom: 16,
  padding: 8,
  textTransform: "uppercase",
};

export const contentRowHeadingCss: CSSObject = {
  ...typographyStyles.fontFamily.noto,
  ...typographyStyles.fontSize.heading2,
  color: constants.colors.ui.neutral[700],
  textAlign: "center",
  lineHeight: "38.4px",
};

export const contentRowDescriptionCss: CSSObject = {
  ...typographyStyles.fontFamily.circular,
  ...typographyStyles.fontSize.textM,
  color: constants.colors.ui.neutral[700],
  paddingBottom: "18px",
  lineHeight: "22px",
  textAlign: "center",
};

export const contentListCss: CSSObject = {
  width: "100%",

  "@media (min-width: 0px)": {
    display: "flex",
    flexDirection: "column",
    borderRadius: "1rem",
    gap: "1rem",
  },
  [mediaQuery.downTo(xs)]: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "auto",
    borderRadius: "1rem",
    gap: "1rem",
  },
  [mediaQuery.downTo(md)]: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(0, 1fr))",
    gridTemplateRows: "1fr",
    borderRadius: "1rem",
    gap: "1rem",
  },
};

export const contentScrollableListCss: CSSObject = {
  width: "100%",
  display: "flex",
};

export const listItemCss: CSSObject = {
  width: "fit-content",
  margin: "0 6px",
};

export const linkContainerCss: CSSObject = {
  padding: 0,
  paddingBottom: "4px",
};
